
export default function Waiver() {

  return (
    <section className="pb-16 bg-white min-h-screen">
      <div className="max-w-6xl mx-auto px-8 sm:px-8 lg:px-0 mt-[30px]">

        <h1 className="text-4xl font-bold text-[#00889D] mb-6">
    Yoga Seven – Liability Waiver
  </h1>

  <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
    RELEASE OF LIABILITY, WAIVER OF CLAIMS, ASSUMPTION OF RISK AND INDEMNITY AGREEMENT
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
    BY SIGNING THIS DOCUMENT, YOU WILL WAIVE CERTAIN LEGAL RIGHTS, INCLUDING THE RIGHT TO SUE. PLEASE READ CAREFULLY.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
    Assumption of Risk & Release of Liability, Waiver of Claims and Indemnity
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    Before attending my first class at Yoga Seven – Hot Yoga & Fitness Studio (“Yoga Seven” or “Yoga 7”), I confirm that I have completed, or will complete, any required pre-exercise screening form and that all information provided is truthful and accurate to the best of my knowledge.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    I acknowledge that participation in yoga, fitness, and heated or infrared exercise programs may, in some circumstances, result in physical injury, illness, or discomfort. I confirm that I have discussed my participation with a physician or qualified healthcare professional where appropriate.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    I, the undersigned, being aware of my own health and physical condition, and having knowledge that participation in any exercise program may be injurious to my health, voluntarily choose to participate in physical activity offered by Yoga Seven.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    With full knowledge of the risks involved, I hereby:
  </p>

  <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
    <li>Assume all risks associated with participation in Yoga Seven classes and activities, whether known or unknown; and</li>
    <li>Consent to participate in such programs of my own free will.</li>
  </ul>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    I agree to fully disclose any physical limitations, injuries, disabilities, medical conditions, illnesses, or pregnancy that may affect my ability to safely participate in Yoga Seven programs.
  </p>

  <h2 className="text-3xl font-bold text-[#00889D] mb-8">
    Release & Waiver
  </h2>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    In consideration of being permitted to participate in programs and services offered by Yoga Seven, I, for myself and on behalf of my heirs, executors, administrators, and assigns, hereby waive, release, and forever discharge Yoga Seven, its owners, directors, officers, employees, instructors, contractors, agents, and representatives (collectively, “Yoga Seven”) from any and all claims, demands, actions, causes of action, losses, damages, costs, or expenses that I have or may have in the future arising from or related to my participation in Yoga Seven activities.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    This release applies to any and all liability, including but not limited to liability arising from:
  </p>

  <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
    <li>Negligence</li>
    <li>Breach of contract</li>
    <li>Breach of any statutory or other duty of care, including duties owed under the Occupiers Liability Act (British Columbia)</li>
  </ul>

  <h2 className="text-3xl font-bold text-[#00889D] mb-8">
    Indemnity
  </h2>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    I agree to indemnify and hold harmless Yoga Seven from any and all claims, demands, damages, costs, or expenses (including legal fees) arising from my participation in Yoga Seven programs or my failure to comply with studio policies or instructor guidance.
  </p>

  <h2 className="text-3xl font-bold text-[#00889D] mb-8">
    Acknowledgment
  </h2>

  <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
    I HAVE READ THIS AGREEMENT AND FULLY UNDERSTAND IT.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
    I AM AWARE THAT BY SIGNING THIS AGREEMENT, OR BY CHECKING A BOX INDICATING THAT I HAVE READ AND UNDERSTOOD THIS AGREEMENT, I AM WAIVING CERTAIN LEGAL RIGHTS, INCLUDING THE RIGHT TO SUE, WHICH I OR MY HEIRS, NEXT OF KIN, EXECUTORS, ADMINISTRATORS, OR ASSIGNS MAY HAVE AGAINST YOGA SEVEN.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    I sign this Agreement freely and voluntarily.
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    Participant Name: _______________________________
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    Signature: _____________________________________
  </p>

  <p className="text-base text-gray-600 mb-6 leading-relaxed">
    Date: _________________________________________
  </p>
      </div>


    </section>
  );
}
